import I18n from "../i18n/i18n";
export const i18n = {
  methods: {
    t: (...args) => I18n.t(...args),
    l: (...args) => I18n.l(...args),
    currentLocale: () => I18n.currentLocale()
  }
};
